import { FC } from "react";
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import {
  setConfirmationByMessageModal,
  setErrorMessageByVoteModal,
  setVoteModal,
} from "../../../store/slices/main";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import { TVoteForm } from "../../../types/vote";
import vote from "../../../api/asyncThuncks/vote";
import {
  selectContestsState,
  setConfirmationByMessage,
} from "../../../store/slices/contests";
import getVote from "../../../api/asyncThuncks/vote";

const VoteFormModal: FC = () => {
  const dispatch = useAppDispatch();
  const { сonfirmationByMessage, voteStatus } =
    useAppSelector(selectContestsState);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<TVoteForm>({
    defaultValues: {
      number: "",
    },
    mode: "onSubmit",
  });

  const onSubmit: SubmitHandler<TVoteForm> = async (data) => {
    dispatch(
      setConfirmationByMessage({
        phone: data.number,
        contestId: сonfirmationByMessage.contestId ?? "",
        audioTrackId: сonfirmationByMessage.audioTrackId,
      })
    );

    try {
      // Используем unwrap() для получения результата!!!
      const result = await dispatch(
        vote({
          phone: data.number,
          contestId: сonfirmationByMessage.contestId,
          audioTrackId: сonfirmationByMessage.audioTrackId,
        })
      ).unwrap();

      dispatch(setVoteModal(false));

      if (result.status === 201) {
        dispatch(setConfirmationByMessageModal(true));
      } else {
        dispatch(setErrorMessageByVoteModal(true));
      }
    } catch (error) {
      dispatch(setVoteModal(false));
      dispatch(setErrorMessageByVoteModal(true));
    }
  };

  return (
    <div className="w-full flex flex-col items-center px-2 sm:px-8">
      <div className="w-full h-[18rem] text-center sm:w-[30rem]">
        <h2 className="text-xl font-bold" id="modal-title">
          Підтвердження голосу
        </h2>
        <h5 className="text-sm leading-6 pt-3">
          Підтвердити свій голос через SMS авторизацію. <br />
          За кожну пісню можна проголосувати лише один раз.
        </h5>

        <form onSubmit={handleSubmit(onSubmit)} className="pt-5">
          <div className="w-full flex-col">
            <div className="pt-1.5">
              <Controller
                name="number"
                control={control}
                rules={{
                  required: "От халепа! Це поле обовʼязкове",
                  pattern: {
                    value: /^\+380[0-9]{9}$/,
                    message: "Невірний формат номеру телефону",
                  },
                }}
                render={({ field }) => (
                  <>
                    <input
                      placeholder="Вкажіть номер телефону"
                      type="tel"
                      {...field}
                      onChange={(e) => {
                        let value = e.target.value;

                        value = value.replace(/[^\d+]/g, "");

                        if (
                          value === "" ||
                          (!value.startsWith("+380") && value.length <= 4)
                        ) {
                          value = "+380" + value.replace(/^\+?380?/, "");
                        }

                        if (value.length > 13) {
                          value = value.substring(0, 13);
                        }

                        field.onChange(value);
                      }}
                      onFocus={(e) => {
                        // При фокусе, если поле пустое, добавляем +380
                        if (e.target.value === "") {
                          field.onChange("+380");
                        }
                      }}
                      className={`box-border w-full px-1.5 py-3 text-sm font-normal border-[1.5px] rounded-md outline-none ${
                        errors.number
                          ? "border-[#EC221F] focus:border-[#EC221F]"
                          : "border-light_gray focus:border-orange focus:border-2"
                      }`}
                    />
                    <p
                      className={`text-[13px] mt-1 min-h-[1.5rem] ${
                        errors.number ? "text-[#EC221F]" : "text-transparent"
                      }`}
                    >
                      {errors.number?.message || " "}
                    </p>
                  </>
                )}
              />
            </div>
          </div>
          <div className="w-full flex justify-center">
            <button
              type="submit"
              className="w-full mt-1 px-3 py-3 bg-orange text-sm text-white rounded-md hover:bg-orange-dark transition"
            >
              Продовжити
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default VoteFormModal;
